import React, { useState, useEffect, useRef, memo } from "react";
import { getIcons } from "../../Constant/Constant";
import Loader from "../../Constant/Loader";
import { IoSearch } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";
import { BsFire } from "react-icons/bs";

const LeadTable = ({
  data = [],
  columns = [],
  onRowSelect,
  onSelectionChange,
  selectedRows = [],
  onPageChange,
  handleReasignTeam,
  currentPage = 1,
  pageSize = 10,
  handleSearchLead,
  searchQuery,
  setSearchQuery,
  disPlay = true,
  loading = false,
  nextPageToken = null,
  prevPageToken = null,
  hasMoreLeads = false,
  handleFilterLeads,
  hotLead = false,
}) => {
  const selectAllCheckboxRef = useRef(null);
  const icons = getIcons();
  const selected = selectedRows || [];

  const allSelected =
    data.length > 0 && data.every((row) => selected.includes(row.id));
  const someSelected =
    selected.length > 0 &&
    data.some((row) => selected.includes(row.id)) &&
    !allSelected;

  useEffect(() => {
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  const handleSelectAll = (e) => {
    const currentPageIds = data.map((item) => item.id);
    if (e.target.checked) {
      const newSelected = [...new Set([...selected, ...currentPageIds])];
      onSelectionChange?.(newSelected, "all");
    } else {
      const newSelected = selected.filter((id) => !currentPageIds.includes(id));
      onSelectionChange?.(newSelected, null);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSelectRow = (id) => {
    let newSelected;
    if (selected.includes(id)) {
      newSelected = selected.filter((item) => item !== id);
    } else {
      newSelected = [...selected, id];
    }
    onSelectionChange?.(newSelected, id);
  };

  const renderCellContent = (column, row) => {
    const cellData = row[column.key];
    if (column.render) return column.render(cellData, row);
    if (Array.isArray(cellData)) {
      return cellData
        .map((item) => item.name || item.label || JSON.stringify(item))
        .join(", ");
    }
    if (typeof cellData === "object" && cellData !== null) {
      return cellData.name || cellData.label || JSON.stringify(cellData);
    }
    return cellData;
  };

  const handlePageChange = (token, direction) => {
    onPageChange?.(token, direction);
  };

  return (
    <div className="w-full overflow-hidden rounded-lg shadow px-5 pt-4 bg-white">
      <div className="flex items-center justify-between rounded-lg px-3 py-2 bg-[#F6F6F6] ">
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-3">
            {hotLead ? (
              <div className="text-2xl text-customGreen">
                <div className="flex  items-center gap-4 text-center">
                  <div className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] px-3 font-medium shadow-soft-all w-full rounded-[10px] p-2">
                    <BsFire className="text-xl" />
                    <div>Overall Hot Leads</div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="relative w-[385px] ">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                    <IoSearch />
                  </span>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearchLead();
                      }
                    }}
                    className="pl-10 pr-4 py-2 w-full border h-[49px] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-customGreen"
                  />
                </div>
                <button
                  disabled={loading}
                  onClick={handleSearchLead}
                  className={`${
                    loading
                      ? "bg-slate-400 cursor-not-allowed"
                      : "bg-customGreen"
                  } w-[131px] h-[50px] rounded-[10px] text-white`}
                >
                  Search
                </button>
              </>
            )}

            {selectedRows.length > 0 ? (
              <div>
                <div className="flex w-[269px] h-[50px] text-base bg-white  rounded-md px-3 text-customGreen font-medium py-2 items-center gap-6">
                  <div className="flex items-center gap-4">
                    {selectedRows?.length} Select in this page out of {pageSize}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="flex items-center gap-5">
          {disPlay && (
            <button
              onClick={handleReasignTeam}
              disabled={selectedRows.length === 0}
              className={`${
                selectedRows.length === 0
                  ? "bg-[#70B89F] cursor-not-allowed"
                  : "bg-customGreen cursor-pointer"
              } 
               text-white w-[131px] h-[50px] rounded-[10px]  hover:bg-appGreenHover transition duration-300`}
            >
              Reassign
            </button>
          )}
          <div className="flex items-center gap-4">
            <button
              onClick={handleFilterLeads}
              className="bg-white  justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px]   flex items-center gap-3 text-customGreen py-2 px-4  hover:bg-appGreenHover transition duration-300"
            >
              Filters
              <MdFilterListAlt />
            </button>
          </div>
        </div>
      </div>
      <table className="w-full mt-[15px]">
        <thead className="">
          <tr className=" bg-[#F6F6F6] rounded-[15px] ">
            {disPlay && (
              <th className="p-4">
                <input
                  type="checkbox"
                  ref={selectAllCheckboxRef}
                  checked={allSelected}
                  onChange={handleSelectAll}
                  className="form-checkbox h-4 w-4 text-blue-600"
                />
              </th>
            )}
            {columns.map((column) => (
              <th
                key={column.key}
                className="p-4 text-center text-sm font-medium text-gray-600"
                style={{ width: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row) => {
            const isItemSelected = selected.includes(row.id);
            return (
              <tr
                key={row.id}
                className={`border-t hover:bg-gray-50 ${
                  isItemSelected ? "bg-blue-50 border-l-4 border-blue-500" : ""
                }`}
                onClick={() => onRowSelect?.(row)}
              >
                {disPlay && (
                  <td className="p-4">
                    <input
                      type="checkbox"
                      checked={isItemSelected}
                      onChange={() => handleSelectRow(row.id)}
                      onClick={(e) => e.stopPropagation()}
                      className="form-checkbox h-4 w-4 text-blue-600"
                    />
                  </td>
                )}
                {columns.map((column) => (
                  <td
                    key={`${row.id}-${column.key}`}
                    className="p-4  text-center"
                  >
                    {renderCellContent(column, row)}
                  </td>
                ))}
              </tr>
            );
          })}

          {loading && (
            <tr>
              <td colSpan={columns.length + 1} className="p-4 text-center">
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
                </div>
              </td>
            </tr>
          )}

          {!loading && data.length === 0 && (
            <tr>
              <td colSpan={columns.length + 1} className="p-4 text-center">
                <div className="flex flex-col items-center justify-center space-y-4">
                  <div className="text-customGreen font-semibold mt-[20px]">
                    Apply Filter To See Lead Table
                  </div>
                  <img
                    src={icons?.leadEmpty}
                    alt="No Data"
                    className="w-80  mt-[20px] h-auto"
                  />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="flex items-center justify-between border-t p-4 px-3">
        <div className="text-sm text-gray-500">
          <select
            className="border rounded p-2"
            onChange={(e) => onPageChange?.(e.target.value, "size")}
            value={pageSize.toString()}
          >
            <option value="10">1 - 10</option>
            <option value="50">1 - 50</option>
            <option value="100">1 - 100</option>
          </select>
        </div>

        <div className="flex justify-center my-5 gap-10">
          {currentPage > 1 && (
            <button
              onClick={() => handlePageChange(prevPageToken, "previous")}
              className="mx-1 px-3 py-1 border rounded "
              disabled={loading}
            >
              <img
                src={icons.previousPagination}
                className="w-3"
                alt="Previous"
              />
            </button>
          )}
          <span>{currentPage}</span>

          <button
            onClick={() => handlePageChange(nextPageToken, "next")}
            className={`mx-1 px-3 py-1 border rounded ${
              hasMoreLeads ? "cursor-pointer" : "cursor-not-allowed"
            }`}
            disabled={!hasMoreLeads}
          >
            <img src={icons.nextPagination} className="w-3" alt="Next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(LeadTable);
